var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "communities-list" }, [
    _vm.isLoading
      ? _c("div", [
          _c(
            "div",
            {
              staticClass:
                "communities-list__filter d-flex d-flex-wrap d-flex-justify-between",
            },
            [
              _c("div", { staticClass: "filter-holder d-flex d-flex-wrap" }, [
                _c("h6", [_vm._v("Filters")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "filter-list d-flex d-flex-wrap" },
                  [
                    _c(
                      "li",
                      [
                        _c("FilterLocation", {
                          attrs: { options: _vm.getCategoriesLocationsList },
                          model: {
                            value: _vm.categoryLocationFilter,
                            callback: function ($$v) {
                              _vm.categoryLocationFilter = $$v
                            },
                            expression: "categoryLocationFilter",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getCategoriesList, function (category) {
                      return _c("li", { key: category.id }, [
                        _c("label", { staticClass: "filter-field" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.categoryFilter,
                                expression: "categoryFilter",
                              },
                            ],
                            attrs: { type: "checkbox", id: category.slug },
                            domProps: {
                              value: category.id,
                              checked: Array.isArray(_vm.categoryFilter)
                                ? _vm._i(_vm.categoryFilter, category.id) > -1
                                : _vm.categoryFilter,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.categoryFilter,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = category.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.categoryFilter = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.categoryFilter = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.categoryFilter = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(category.name) +
                              "\n                "
                          ),
                          _c("span", { staticClass: "filter-field__check" }),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "view-all",
                  attrs: { type: "button" },
                  on: { click: _vm.viewAll },
                },
                [_vm._v("View All")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.getPostsListPaged.length
            ? _c(
                "div",
                { staticClass: "communities-list__grid" },
                _vm._l(_vm.getPostsListPaged, function (post, key) {
                  return _c("CommunityCard", {
                    key: key,
                    attrs: {
                      link: post.link,
                      imageUrl: _vm.getThumbnail(post),
                      imageAlt: post.title.rendered,
                      title: post.title.rendered,
                      location: post.acf.location,
                      homeStyle: post.acf.home_style,
                      categories: _vm.postCategoriesList(
                        post.community_category
                      ),
                    },
                  })
                }),
                1
              )
            : _c("div", [_vm._m(0)]),
          _vm._v(" "),
          _vm.postsList.length > _vm.loadedPosts
            ? _c("div", { staticClass: "communities-view-more-box" }, [
                _c("div", { staticClass: "communities-showing" }, [
                  _vm._v(
                    "Showing " +
                      _vm._s(_vm.getPostsListPaged.length) +
                      " of " +
                      _vm._s(_vm.postsList.length) +
                      " Communities"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "communities-view-more",
                    on: {
                      click: function ($event) {
                        return _vm.loadMore()
                      },
                    },
                  },
                  [_vm._v("View More")]
                ),
              ])
            : _vm._e(),
        ])
      : _c("div", [
          _c("div", { staticClass: "loader" }, [
            _vm._v("\n      Loading...\n    "),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "communities-list__filter-not-found" }, [
      _c("h1", [_vm._v("Communities not found")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }